import {
    addSelectedSite,
    getAllSites as getAllSitesOcc,
    getSelectedSiteIds as getSelectedSiteIdsDomain,
    loadAllSites,
    removeSelectedSite
} from '@vista-digital/occ-domain'

import { Site } from '@vista-digital/ocapi-types/v1'

export async function getSelectedSiteIds(): Promise<string[]> {
    await loadAllSites()

    return getSelectedSiteIdsDomain()
}

export async function setSelectedSiteIds(sites: string[]): Promise<void> {
    clearSelectedSites()

    sites.forEach(s => addSelectedSite(s))
}

export async function getAllSites(): Promise<Site[]> {
    await loadAllSites()

    return getAllSitesOcc()
}

export async function clearSelectedSites(): Promise<void> {
    const currentSites = await getSelectedSiteIds()

    currentSites.forEach(s => removeSelectedSite(s))
}
